import ServiceInfo from "../../../../../../dto/ServiceInfo"

export enum ActionType {
    SERVICE_INFO_LOADING = 'SERVICE_INFO_LOADING',
    SERVICE_INFO_DATA = 'SERVICE_INFO_DATA',
    SERVICE_INFO_ERROR = 'SERVICE_INFO_ERROR',
    SERVICE_ADD_ORDER_LOADING = 'SERVICE_ADD_ORDER_LOADING',
    SERVICE_ADD_ORDER_DONE = 'SERVICE_ADD_ORDER_DONE',
    SERVICE_ADD_ORDER_ERROR = 'SERVICE_ADD_ORDER_ERROR',

}

export interface ActionServiceInfo {
    type: ActionType.SERVICE_INFO_DATA,
    list: ServiceInfo[]
}

export interface ActionServiceInfoFetchError {
    type: ActionType.SERVICE_INFO_ERROR,
    message: String
}
export interface ActionAddOrderError {
    type: ActionType.SERVICE_ADD_ORDER_ERROR,
    message: String
}
type Action = ActionServiceInfo | ActionServiceInfoFetchError | ActionAddOrderError

export default Action